import { ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IRegion } from "../interfaces/iregion";
import { RegionService } from "../services/region.service";
import { Observable } from "rxjs";

@Injectable()
export class RegionsResolver {

    constructor(private regionService: RegionService) {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<IRegion[]> {
        // todo - replace with parameter
        // return this.dashboardService.getDashboard(route.params.id);
        return this.regionService.getRegions();
    }
}